// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bdd2","placeholdersHeader":"styles_placeholdersHeader__26wck","editorStyle":"styles_editorStyle__1veA_","placeholdersBox":"styles_placeholdersBox__27Dmb"};